import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.ModuleB');

    return (
        <div className={styles.comp} id="ModuleB">
          <EcoSpace />
          <EcoSection
            title={t('title')}
            desc={t('desc')}
          />
          <EcoSpaceSmall />
          <EcoImg
            pc="https://websiteoss.ecoflow.com/upload/image/1745459076021/MB.jpg"
            pad="https://websiteoss.ecoflow.com/upload/image/1745459076021/MB.jpg"
            h5="https://websiteoss.ecoflow.com/upload/image/1745459076406/MB-h5.jpg"
          />
        </div>
    );
}